import React from "react";
import { Result } from "antd";
import { Link } from "react-router-dom";
export default class NotFoundPage extends React.Component {
  render() {
    return (
        <Result
          status="404"
          title="404"
          subTitle={<p>您沒有權限進入該頁面或頁面不存在，請點選 <Link to="/">此處</Link> 返回首頁。</p>}
        ></Result>
    );
  }
}
